import { render, staticRenderFns } from "./PushApplication.vue?vue&type=template&id=063751c3&"
import script from "./PushApplication.vue?vue&type=script&lang=ts&"
export * from "./PushApplication.vue?vue&type=script&lang=ts&"
import style0 from "./PushApplication.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports